import { useTranslation } from 'react-i18next';
import NotificationBadge from '../../notifications/components/NotificationBadge';

export default function HomeHeader() {
  const { t } = useTranslation();
  return (
    <div className="flex w-full items-center justify-between px-[24px] py-[11px]">
      <h1 className="text-[26px] font-bold leading-[31px] text-text-main-lv1">
        {t('tabs.collections')}
      </h1>
      <NotificationBadge />
    </div>
  );
}
